'use client';

import { Link } from '@/i18n/navigation';

export default function NavigationLink({
  href,
  ...rest
}) {

  return (
    <Link
      aria-current="page"
      className='inline-block px-2 py-2 transition-colors text-gray-400 hover:text-gray-200'
      href={href}
      {...rest}
    />
  );
}
